export default {
    header: {
        logout: 'Sign out',
        changePassword: 'Change Password'
    },
    tabs: {
        inquireGoods: 'Search',
        purchasingModule: 'Purchasing module',
        changePassword: 'Change Password'
    },
    search: {
        yes: 'Yes',
        no: 'No'
    },
    goods: {
        codeSearch: 'Search',
        codeSearchPlaceholder: 'Product Code',
        isStock: 'stock > 0',
        tatting: 'Woven',
        knit: 'Knitting',
        alias: 'alias',
        bulk: 'Bulk Stock',
        sample: 'Sample Stock',
        meter: 'M',
        composition: 'Composition',
        width: 'Width',
        weight: 'Weight',
    },
    login: {
        title: 'SCM',
        login: 'Sign in',
        account: 'Account',
        password: 'Password'
    },
    changePassword: {
        currentPassword: 'Current Password',
        currentPasswordPlaceholder: 'Not less than 6 characters',
        newPassword: 'New Password',
        newPasswordPlaceholder: 'Please enter',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Re-enter new password',
        changePassword: 'Change Password',
        submit: 'Submit',
        close: 'Close',
        firstLoginMsg: 'Please change password',
        confirmPasswordMsg: 'Not consistent with the new password',
        modifySuccessMsg: 'Success',
    }
};